import snapEngageView from './snapEngageView.html';
import { AssetManager } from 'components/sharpr/assetManager/AssetManager';

export default function snapEngageComponent() {
	return {
		restrict: 'E',
		scope: {},
		bindToController: {},
		controllerAs: 'vm',
		controller: snapEngageComponentCtrl,
		template: snapEngageView,
	};
}

class snapEngageComponentCtrl {
	constructor($window, $timeout, Identity, Cookies) {
		'ngInject';
		// save injections
		this.$window = $window;
		this.$timeout = $timeout;
		this.Identity = Identity;
		// defaults
		this.allowSnapEngage = Cookies.optionalConsentGranted();
		if (!this.allowSnapEngage) {
			return;
		}
		this.isAgentOnline = false;
		if (Identity.user()) {
			// setup
			this.setUserInfo();
			// include snap engage snippet
			let snapUrl = '//commondatastorage.googleapis.com/code.snapengage.com/js/000d2c90-c1fc-446d-8cfa-cfa3fe793e91.js';
			AssetManager.script(snapUrl, {
				async: true,
				defer: true,
			}).then(this.onSnapLoaded.bind(this));
		}
	}

	setUserInfo() {
		const user = this.Identity.user();
		this.$window.User_Name = `${user.fname_preferred || user.fname} ${user.lname_preferred || user.lname} <${
			user.email
		}>`;
		this.$window.User_Role = user.role;
		this.$window.Current_Instance = (this.Identity.currentClient() || {}).name;
		this.$window.Current_Page = this.$window.document.title.replace(/ :: .+$/, '');
	}

	onSnapLoaded() {
		//We don't want the message button in the bottom right corner to show on the sharpr platform
		this.$window.SnapEngage.hideButton();
		// show "live chat" instead of "contact us" when agent is online
		this.$window.SnapEngage.getAgentStatusAsync(online => {
			this.$timeout(() => (this.isAgentOnline = online));
		});
		// do GA event tracking; one event if they open the chat, one if they type something
		// https://developers.google.com/analytics/devguides/collection/analyticsjs/events
		let seAgent;
		this.$window.SnapEngage.setCallback('OpenProactive', function (agent, msg) {
			seAgent = agent;
			ga('send', 'event', 'SnapEngage', 'open chat window', seAgent);
		});
		this.$window.SnapEngage.setCallback('StartChat', function (email, msg, type) {
			ga('send', 'event', 'SnapEngage', 'first message', seAgent);
		});
	}

	openChat() {
		if (!this.allowSnapEngage) {
			window.location.href = 'mailto:support@sharpr.com';
			return;
		}
		this.$window.SnapEngage.setUserEmail(this.Identity.user().email);
		this.$window.SnapEngage.openProactiveChat(true, true, 'Hello. How can I help you?');
	}
}
